export default __webpack_public_path__ + "static/media/certificate-icon.79c77787.svg";